import { Box, Flex } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'

import { TopDrop } from '../../types/lucksterEvent'
import { useLanguagePath } from '../../hooks/useI18nRoute'
import PBoxCardImgComponent from '../PBoxCardImgComponent'
import CornerBorder from '../Icons/CornerBorder'
import { getRarityColorMap, rarityType } from '../../constants/skinPropertes'
import { colors } from '../../theme/cssVariables'
import { getSkinDisplayRarity } from '../../utils/getSkinDisplayRarity'

import Avatar from '../Avatar'
import { useSkinTranslations } from '../../hooks/useSkinTranslations'

const Back = (props: TopDrop) => {
  const navigate = useNavigate()
  const getPath = useLanguagePath()
  const { rarityEnum } = useSkinTranslations()
  const onClickBox = () => {
    navigate(getPath(`pbox/detail/${props?.box?.boxId}`))
  }

  const handleGotoProfile = () => {
    // navigate(getPath(`portfolio/${props?.user?.uuid}`))
    return null
  }
  const displayRarity = getSkinDisplayRarity(props?.rarity, props?.name)
  const rarity = rarityEnum[displayRarity as keyof typeof rarityEnum]
  return (
    <CornerBorder color={getRarityColorMap(rarity as unknown as rarityType).border}>
      <Flex width={'100%'} height={'100%'} position={'relative'} cursor={'pointer'}>
        <Box onClick={onClickBox}>
          <PBoxCardImgComponent
            pboxImg={props?.box?.boxImg}
            treasureImg={props?.box?.treasureImg}
            maxW={['65%', '80%']}
            margin={'0 auto'}
            lightBg={props?.box?.blImg}
          />
        </Box>

        <Box position={'absolute'} bottom={'5%'} right={'5%'} onClick={handleGotoProfile}>
          <Avatar
            url={props?.user?.avatar}
            border={`2px solid ${colors.colorA1}`}
            bg={colors.theme}
            padding={'2px'}
          />
        </Box>
      </Flex>
    </CornerBorder>
  )
}

export default Back
